import { Injectable } from '@angular/core';
import { PlatformMockApiService } from '@platform/lib/mock-api';
import { cloneDeep } from 'lodash-es';
import {recyclerData} from "./data";

@Injectable({providedIn: 'root'})
export class RecyclersMockApi
{
    private _recyclerData: any = recyclerData;

    constructor(private _platformMockApiService: PlatformMockApiService)
    {
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // Register Mock API handlers
    // -----------------------------------------------------------------------------------------------------
    registerHandlers(): void
    {
        this._platformMockApiService.onGet('api/recycler-data').reply(() => [200, cloneDeep(this._recyclerData)]);
    }
}
